import React from "react";
import PropTypes from "prop-types";

import { OrderObject, CurrentUserObject } from "../Queries/OrderQuery";
import ProcessLinesQuery from "../OrderLevelProcessBtns/ProcessLinesQuery";
import ShipmentsModal from "./ShipmentsModal";

class ShipmentsModalWrapper extends React.Component {
  state = { createShipmentPopupOpen: false };

  render() {
    const { order, awaitingCallPending, currentUser } = this.props;
    
    return (
      <React.Fragment>
        {this.props.children(this.toggleCreateShipmentPopup)}
        
        {this.state.createShipmentPopupOpen && (
          <ProcessLinesQuery
            orderId={order.id}
            queryField="shippable"
            render={({ orderLines }) =>
              orderLines && (
                <ShipmentsModal
                  order={order}
                  currentUser={currentUser}
                  awaitingCallPending={awaitingCallPending}
                  show={this.state.createShipmentPopupOpen}
                  orderLines={orderLines}
                  toggleOpen={this.toggleCreateShipmentPopup}
                />
              )
            }
          />
        )}
      </React.Fragment>
    );
  }

  toggleCreateShipmentPopup = () =>
    this.setState({ createShipmentPopupOpen: !this.state.createShipmentPopupOpen });
}

ShipmentsModalWrapper.propTypes = {
  order: OrderObject.isRequired,
  awaitingCallPending: PropTypes.bool.isRequired,
  currentUser: CurrentUserObject.isRequired,
  children: PropTypes.func.isRequired
};

export default ShipmentsModalWrapper; 